import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ButtonStyleType } from '../../types/misc';
import { BUTTON_STYLES } from '../../constants/constants';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ButtonComponent {
  @Input() disabled = false;

  @Input() submit = false;

  @Input() fullWidth = true;

  @Input() buttonStyle: ButtonStyleType = BUTTON_STYLES.NONE;

  @Input() buttonSize: 'medium' | 'extra-small' | null = null;

  get buttonClasses(): string[] {
    const classes = ['button'];

    if (this.disabled) {
      classes.push('button--disabled');
    }

    if (this.fullWidth) {
      classes.push('button--full-width');
    }

    if (this.submit) {
      classes.push('button--action');
    }

    if (this.buttonStyle) {
      classes.push(`button--${this.buttonStyle}`);
    }

    if (this.buttonSize) {
      classes.push(`button--${this.buttonSize}`);
    }

    return classes;
  }
}
